import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Avatar, Button, MenuItem, Box, SvgIcon, Grow, Popper, Paper, ClickAwayListener } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './MenuButton.scss';
import AddIcon from '@mui/icons-material/Add';
import parse from 'html-react-parser';
import { useFormSubmit } from '../../utils/useFormSubmit';
import constants from '../../constants';

const MenuButton = ({ menu, toggleDropdown, setOpenMenu, openMenu, hasNotifications, handleNavigate, natPayEncodedMessage }) => {
  const history = useHistory();
  const [openMenus, setOpenMenus] = useState(Array(menu.length).fill(false));
  const buttonRefs = useRef(new Array(menu.length).fill(null));
  const { formRef, inputRef, handleSubmit } = useFormSubmit(natPayEncodedMessage);

  useEffect(() => {
    if (openMenu) {
      handleClick(null, 0);
    }
  }, [openMenu]);

  const handleClick = (event, menuIndex) => {
    setOpenMenus((prevOpenMenus) =>
      prevOpenMenus.map((prevOpen, i) => (i === menuIndex ? !prevOpen : prevOpen))
    );
  };

  const handleClose = (event, index) => {
    if (setOpenMenu !== undefined) {
      setOpenMenu(false);
    }
    setOpenMenus((prevOpenMenus) =>
      prevOpenMenus.map((prevOpen, i) => (i === index ? false : prevOpen))
    );
  };

  const handleMenuItemClick = (menuItem) => {
    if (menuItem.link !== '') {
      if (history.location.pathname !== '/') {
        window.location.replace(`${menuItem.link}?dropdown=true`);
      } else {
        toggleDropdown();
        setOpenMenus(Array(menu.length).fill(false));
      }
    }
  };

  const createNotificationBlock = (item) => {
    const notificationBorderType = item.priority && item.priority.includes('critical') ? 'notification-border critical' : 'notification-border';
    const notificationBlock = (
      <>
        <Box className='notification-box'>
          <Box className={notificationBorderType} />
          <Box className='notification-content'>
            {item.title && (
              <Box className='notification-header'>
                <span className='notification-title'>{parse(item.title)}</span>
                <span className='notification-date'> {item.updatedAt ? new Date(item.updatedAt).toLocaleDateString() : ''}</span>
              </Box>
            )}
            {item.body && (
              <Box className='notification-desc'>{parse(item.body)}</Box>
            )}
          </Box>
        </Box>
        <div className='dropdownSeparator' />
      </>
    );

    return notificationBlock;
  };

  const GoToAMSuite = ({ item }) => (
    <form name="input" action={`${item.link}`} method="post" target="_self"
      onSubmit={async (e) => {
        e.preventDefault();
        const newURL = await handleNavigate();
        if (newURL) {
          window.open(newURL, '_self');
        }
      }}
    >
      <Button className='menu-link-button' disableRipple type="submit">
        {item.style === 'bold' ? (<b>{parse(item.name)}</b>) : (parse(item.name))}
      </Button>
    </form>
  );

  const PolicyDocumentsPortal = ({ item }) => (
    <form name='input' action={`${item.link}`} method='post' target='_blank'
      onSubmit={handleSubmit} ref={formRef}>
      <Button className='menu-link-button' disableRipple type="submit">
        <input type="hidden" name="login" ref={inputRef} />
        {item.style === 'bold' ? (<b>{parse(item.name)}</b>) : (parse(item.name))}
      </Button>
    </form>
  );

  const OtherMenuItem = ({ item, index }) => (
    <MenuItem disableRipple key={'menu-item-' + index}
      onClick={(event) => {
        if (item.name.toLowerCase() === 'start a quote') {
          handleMenuItemClick(item, index);
          return;
        }
        if (item.action !== undefined) {
          item.action(event);
        }
        else if (item.link && item.link !== '') {
          window.open(item.link, item.open);
        }
        setOpenMenus(Array(menu.length).fill(false));
      }}>
      {item.icon && (item.icon === 'plus-icon' ? (<AddIcon />) : (<img src={require(`../../common/assets/img/${item.icon}.png`)} alt={item.icon} className='menu-link-icon' />))}
      {item.style === 'bold' ? (<b>{parse(item.name)}</b>) : (parse(item.name))}
    </MenuItem>
  );

  const defaultListItems = (index, item) => {
    const itemName = item.name.toLowerCase();
    return (
      <Box className={item.type === undefined ? 'menu-links' : item.type}>
        {itemName === constants.goToAmsuite && <GoToAMSuite item={item} />}
        {itemName === constants.policyDocumentsPortal && <PolicyDocumentsPortal item={item} />}
        {itemName !== constants.goToAmsuite && itemName !== constants.policyDocumentsPortal &&
          <OtherMenuItem item={item} index={index} />}
      </Box>
    );
  };

  const createListItem = (index, item) => {
    switch (item.type) {
      case constants.separator:
        return <div className='dropdownSeparator' />
      case constants.activeUser:
        const nameString = item.name.charAt(0) + item.name.charAt(item.name.indexOf(' ') + 1);
        return <Box className='avatar-list-item'><Avatar className='user-avatar'>{nameString}</Avatar>{item.name}</Box>
      case constants.notification:
        return createNotificationBlock(item);
      default:
        return defaultListItems(index, item);
    }
  }

  return (
    <>
      {menu.map((item, index) => (
        <div key={index}>
          <Button
            disableRipple
            aria-controls={`${item.name}-menu`}
            aria-haspopup={true}
            onClick={(event) => handleClick(event, index)}
            className={openMenus[index] ? 'active-menu-button' : 'menu-button'}
            ref={(ref) => (buttonRefs.current[index] = ref)}
          ><div className='menu-button-label'>
              <div className={hasNotifications ? 'badge' : ''}></div>
              {item.icon != null ? (<img src={require('../../common/assets/img/' + item.icon + '.png')} alt={item.name} />)
                : (
                  <>
                    {item.subname == null ? (
                      <div>
                        {item.name}
                      </div>
                    ) : (
                      <div>{item.subname}</div>
                    )}
                    <SvgIcon className='expand-more-icon' component={ExpandMoreIcon} />
                  </>
                )}
            </div>
          </Button>
          <Popper
            open={openMenus[index]}
            anchorEl={buttonRefs.current[index]}
            role={undefined}
            className={(item.menuType === undefined) ? 'dropdown-menu' : item.menuType + '-dropdown-menu'}
            placement="bottom-end"
            transition
            disablePortal
          >
            {({ TransitionProps }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin: 'top',
                }}
              >
                <Paper className='dropdown-list'>
                  <ClickAwayListener
                    onClickAway={(event) => handleClose(event, index)}
                  >
                    <div
                      id={item.name.toLowerCase() + '-menu'}
                      aria-labelledby={item.name.toLowerCase() + '-button'}
                    >
                      {item.name === constants.notifications && (
                        <>
                          <Box className='notifications-title-box'>
                            <div className="notifications-title">Notifications ({item.menuItems.length}{hasNotifications ? ' messages' : ''})</div>
                            <div className='notications-divider' />
                          </Box>
                          <div className='notifications-spacer' />
                        </>
                      )}
                      {item.menuItems.map((menuItem, menuItemIndex) => (
                        <div key={menuItemIndex}>
                          {
                            createListItem(menuItemIndex, menuItem)
                          }
                        </div>
                      ))}
                    </div>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      ))}
    </>
  );
}

export default MenuButton;
